export default {
  actions: {
    addClient ({ commit, state }, client) {
      const index = state.clients.findIndex(item => item.client_id === client.client_id)

      if (index === -1) {
        commit('add', client)
      }
    },
    mergeClient ({ commit, state }, { id, data }) {
      const index = state.clients.findIndex(item => item.client_id === id)

      if (index !== -1) {
        commit('merge', { index, data })
      }
    },
    updateClient ({ commit, state }, client) {
      const index = state.clients.findIndex(item => item.client_id === client.client_id)

      if (index !== -1) {
        commit('update', {index, client})
      }
    },
    setCurrentClient ({ commit, state }, client) {
      const index = state.clients.findIndex(item => item.client_id === client.client_id)

      if (index === -1) {
        commit('add', client)
      } else {
        commit('update', {index, client})
      }

      commit('choose', client.client_id)
    },
    updateDialog ({commit, state}, client) {
      const index = state.clients.findIndex(item => item.client_id === client.client_id)

      if (index !== -1) {
        if (state.clients[index].created_at !== client.created_at) {
          commit('delete', index)
          commit('unshift', client)
        } else {
          commit('update', {index, client})
        }
      } else {
        commit('unshift', client)
      }
    },
    clearClients ({ commit }) {
      commit('remove')
    }
  },
  mutations: {
    add (state, client) {
      state.clients.push(client)
    },
    update (state, {index, client}) {
      state.clients.splice(index, 1, client)
    },
    choose (state, client_id) {
      state.currentClientID = client_id
    },
    delete (state, index) {
      state.clients.splice(index, 1)
    },
    top (state, client) {
      state.clients.unshift(client)
    },
    unshift (state, client) {
      state.clients.unshift(client)
    },
    remove (state) {
      state.clients = []
      state.currentClientID = null
    },
    merge (state, {index, data}) {
      const client = {
        ...state.clients[index],
        ...data
      }
      state.clients.splice(index, 1, client)
    }
  },
  state: {
    clients: [],
    currentClientID: null
  },
  getters: {
    allClients (state) {
      return state.clients
    },
    currentClient (state) {
      return state.clients.find(client => client.client_id === state.currentClientID) || {}
    },
    clientById: (state) => (id) => {
      return state.clients.find(item => item.client_id === id)
    }
  }
}
